import React from 'react';
import { ComponentProps, inject, deps, observer } from '../../../lib/component';
import { style } from 'typestyle';
import { ConnectedArtistLandingPage } from '../../artist/landing-page';
import { spacing } from '../../../theme/spacing';
import { MusicLayout } from '../templates/MusicLayout';
import { TrackLine } from '../molecules/TrackLine';
import { ArtistSidebar } from '../organisms/ArtistSidebar';
import { Release } from '../../release';
import { Loading } from '../../loading/loading';

interface ArtistPageProps extends ComponentProps {}

const styles = {
  loading: style({
    margin: '25vh 0',
  }),
  title: style({
    margin: 0,
    textAlign: 'center',
  }),
  releases: style({
    marginTop: spacing.XLARGE,
  }),
};

export const ArtistPage: React.FC<ArtistPageProps> = inject(deps)(
  observer(
    ({
      model: {
        page: { artist },
      },
      controller: {
        ui: { handleClickLink },
      },
    }) => {
      if (!artist.loading && artist.isMissing) return <ConnectedArtistLandingPage slug={artist.slug} />;

      if (artist.loading) {
        return <Loading className={styles.loading} />;
      }

      const MastheadContent = <h1 className={styles.title}>{artist.artist.name}</h1>;

      const MainContent = (
        <>
          {!artist.release && artist.tracks.length > 0 && (
            <div>
              <h3 data-test-top-tracks-header>Top tracks</h3>

              {artist.tracks.map((track) => (
                <TrackLine key={track.identity} track={track} />
              ))}
            </div>
          )}

          {artist.releases.length > 0 && (
            <div className={styles.releases}>
              {[...artist.releases]
                .sort((a, b) => b.release_date.timestamp - a.release_date.timestamp)
                .map((release, index) => (
                  <Release key={index} model={artist.releaseModels[release.identity]} onClickLink={handleClickLink} />
                ))}
            </div>
          )}

          {artist.misc && artist.misc.length > 0 && (
            <div className={styles.releases}>
              <h3>More tracks by this artist</h3>

              {artist.misc.map((track, i) => (
                <TrackLine key={track.identity} track={track} />
              ))}
            </div>
          )}
        </>
      );

      const SidebarContent = <ArtistSidebar artist={artist.artist} similarArtists={artist.similarArtists} />;

      return (
        <MusicLayout mastheadContent={MastheadContent} mainContent={MainContent} sidebarContent={SidebarContent} />
      );
    }
  )
);
